<template>
  <v-card v-if="model.cve_empleado" elevation="0">
    <v-tabs v-model="tabs" background-color="primary" dark>
      <v-tab>Registro Asistencia</v-tab>
      <v-tab>Justificaciones</v-tab>
      <v-tab>otro</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">

      <v-tab-item>
        <v-card width="auto" outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="6" md="4" lg="3">
                <DatePicker :itemAction="datePikerInicio" :on-success="actionFieldData"/>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <DatePicker :itemAction="datePikerFinal" :on-success="actionFieldData"/>
              </v-col>
              <v-col cols="12">
                <DataTableMain :datatable="table" :on-success='successTableAction' :itemsAction='tableAction' />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card width="auto" outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="6" md="4" lg="3">
                <DatePickerMonth :itemAction="datePikerMonth" :on-success="actionFieldData"/>
              </v-col>
              <v-col cols="12">
                <DataTableMain :datatable="tableIncidencia" :on-success='successTableAction' :itemsAction='tableAction' />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import DatePicker from '@/components/fields/DatePicker'
import DatePickerMonth from '@/components/fields/DatePickerMonth'

import { Permission } from '@/mixins/permissionMain'
import { setTimeout } from 'timers'
export default {
  props: ['model', 'onSuccess'],
  mixins: [Permission],
  data: () => ({
    tabs: 0,
    datePikerInicio: { field: 'textDatePicker', name: 'Fecha Inicio', nameid: 'fecha_inicio', rules: true, default: true, cols: 6 },
    datePikerFinal: { field: 'textDatePicker', name: 'Fecha Final', nameid: 'fecha_final', rules: true, default: true, cols: 6 },
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Procesado', value: 'procesado', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Registro', value: 'Created', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateAdscripcionData', code: 'nomina-adscripciones.update' }
        ]
      },
      footer: {
        paging: true
      }
    },

    datePikerMonth: { field: '', name: 'Fecha Mensual', nameid: 'dateMonth', rules: true, default: true, cols: 6 },
    tableIncidencia: {
      header: {
        options: [
          // { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshIncidenciaData', code: 'libre', hidden: '' },
          { title: 'Nueva Incidencia', icon: 'mdi-plus', color: 'success', action: 'newIncidenciaData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Fecha Indidencia', value: 'fecha', class: 'black--text' },
          { text: 'Tipo Incidencia', value: 'tipo_incidencia.motivo', class: 'black--text' },
          { text: 'Empleado', value: 'adscripcion.empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'adscripcion.departamento.nombre', class: 'black--text' },
          { text: 'Procesado', value: 'procesado', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateAdscripcionData', code: 'nomina-adscripciones.update' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: {},
    itemInsumos: {}
  }),
  components: {
    DataTableMain,
    DatePicker,
    DatePickerMonth
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableIncidencia })
  },
  methods: {
    ...mapActions(['postServiceListActionSecound', 'GETListObjectsTwoService']),
    ...mapMutations([]),
    /* *==========*==========*==========*==========*==========* */
    successTableAction (item) {
      item.item = this.model
      this.onSuccess(item)
    },
    tableAction (item) {
      this.onSuccess(item)
    },
    /* *==========*==========*==========*==========*==========* */
    actionFieldData (obj) {
      if (obj.id === 'dateMonth') {
        const router = this.get_urls['GET/asistencia/incidencia/show']
        setTimeout(() => { this.GETListObjectsTwoService({ url: router, addicional: `?${obj.id}=${obj.data}` }) }, 300)
        return
      }

      this.params[obj.id] = (obj.data) ? obj.data : null
      this.table.header.loading = true
      setTimeout(() => { this.getUrl('POST/asistencia/show') }, 300)
    },
    getUrl (objet) {
      const router = this.get_urls[objet]
      this.postServiceListActionSecound({ url: router, data: this.params })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectsSecound', 'get_objectsTwo', 'get_ResponseDataDialog'])
  },
  watch: {
    model (val) {
      this.params = { adscripcion_id: val.id, cve_empleado: val.cve_empleado }
    },
    get_objectsSecound (val) {
      if (val) {
        this.table.header.loading = false
        this.table.body.data = val
      }
    },
    get_objectsTwo (val) {
      if (val) {
        this.tableIncidencia.header.loading = false
        this.tableIncidencia.body.data = val
      }
    },
    get_ResponseDataDialog ({ name, model }) {
      console.log(name, model)
      if (name === 'saveIncidencia') {
        let findobject = -1
        this.tableIncidencia.body.data.map((el, i) => { if (el.id === model.id) findobject = i })
        if (findobject !== -1) Object.assign(this.tableIncidencia.body.data[findobject], model)
        else this.tableIncidencia.body.data.push(model)
      }
    }
  }
}
</script>

<style>
.container-foto {
  position: relative
}
.foto {
  display: block;
  margin: 0 auto;
}
</style>
